// extracted by mini-css-extract-plugin
export default {"wrapper":"file-uploader_wrapper__8twG2"};